export default __webpack_public_path__ + "static/media/sabinestroh_zwei.970aaa02.jpg";